export const CLAIM_FILE_TYPE = {
  DAMAGE_PHOTO: 'DAMAGE_PHOTO',
  DAMAGE_AREA_SCREENSHOT: 'DAMAGE_AREA_SCREENSHOT',
};
